module.exports = __webpack_public_path__ + "img/service4.c544cf49.png";